// extracted by mini-css-extract-plugin
export default {"addToCartControl":"S1-z","giftCard":"T1-z","btnContainer":"U1-z","cartButton":"V1-z","disabled":"W1-z"};